import { object, string } from 'yup';

import { messages } from './messages';

export const bundlesSchema = object({
  productId: string().required(messages.productSelectionRequired),
});
